export const environment = {
	production: true,
	// serverUrl: "https://devserver.my-cliniq.com",
	// apiUrl: "https://devserver.my-cliniq.com/v1",
	serverUrl: "//devserver.my-cliniq.com",
	// apiUrl: "//dev.my-cliniq.com/v1",
	// apiUrl: "https://devserver.my-cliniq.com/v1",
} //ng build -c=dev
